module.exports = __webpack_public_path__ + "img/icon-ticket-single.75d29a84.svg";